// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__Z47d9","meals-appear":"AvailableMeals_meals-appear__Gy3Ec"};